// extracted by mini-css-extract-plugin
export var active = "_1l-7";
export var container = "_1l-0";
export var evenWidth = "_1l-4";
export var large = "_1l-5";
export var outlet = "_1l-8";
export var slide = "_1l-2";
export var small = "_1l-6";
export var tab = "_1l-3";
export var tabs = "_1l-1";